// eslint-disable  react-hooks/rules-of-hooks
import { MainSelector, RootStateType } from "@Store/store";
import { IChannel } from "@Interfaces";

const selectIsVoteRegistered = () =>
    MainSelector((state: RootStateType) => {
        return state.poll?.["voteRegistered"];
    });
const selectReportByPollId = (
    channelId: string | undefined,
    pollId: string
): any =>
    MainSelector((state: RootStateType) => {
        const channels = state.channels.channels;
        const targetChannels = channelId
            ? channels.filter((channel: IChannel) => channel._id === channelId)
            : channels;

        for (const channel of targetChannels) {
            const poll = channel.polls?.find(
                (channelPoll) => channelPoll._id === pollId
            );
            if (poll) {
                return poll.report;
            }
        }

        return undefined;
    });

const selectPollWithChannelByPollId = (pollId: string) =>
    MainSelector((state: RootStateType) => {
        for (const channel of state.channels.channels) {
            const poll = channel.polls?.find(
                (channelPoll) => channelPoll._id === pollId
            );
            if (poll) {
                return { poll, channelId: channel._id };
            }
        }
        return null;
    });

export default {
    selectIsVoteRegistered,
    selectReportByPollId,
    selectPollWithChannelByPollId,
};
